import { Carousel } from './Carousel';
import { Show } from '../types/types';
import { SHOW_IMAGES, SHOW_COMING_SOON_IMAGES } from '../constants';
import { CarouselCard } from './CarouselCard';
import { useScreenSize } from '@hooks/useScreenSize';

interface ProgrammesCarouselProps {
  programmes: Show[];
  onProgrammeClick: (programme: Show) => void;
  selectedProgrammeName: string;
}

export const ProgrammesCarousel = ({ programmes, onProgrammeClick, selectedProgrammeName }: ProgrammesCarouselProps) => {
  const { isMobile } = useScreenSize();
  const allShowNames = Object.keys(SHOW_IMAGES);

  const apiProgrammesMap = new Map(programmes.map(programme => [programme.name, programme]));

  const availableProgrammes = allShowNames
    .filter(programmeName => {
      const displayName = programmeName;
      return apiProgrammesMap.has(displayName);
    })
    .map(programmeName => {
      const displayName = programmeName;
      const apiProgramme = apiProgrammesMap.get(displayName);
      return {
        name: programmeName,
        displayName: displayName,
        show_image: apiProgramme?.show_image || programmeName,
        isAvailable: true,
        apiProgramme,
      };
    });

  const comingSoonProgrammes = allShowNames
    .filter(programmeName => {
      const displayName = programmeName;
      return !apiProgrammesMap.has(displayName);
    })
    .map(programmeName => {
      const displayName = programmeName;
      return {
        name: programmeName,
        displayName: displayName,
        show_image: programmeName,
        isAvailable: false,
        apiProgramme: null,
      };
    });

  const allProgrammes = [...availableProgrammes, ...comingSoonProgrammes];

  const renderProgramme = (programme: any) => {
    const isAvailable = programme.isAvailable;
    const imageName = programme.name;
    const imagePath = isAvailable
      ? SHOW_IMAGES[imageName] || 'thumb_generic_flux_news.png'
      : SHOW_COMING_SOON_IMAGES[imageName] || 'thumb_generic_flux_news_soon.png';

    return (
      <CarouselCard
        title={programme.name}
        imagePath={imagePath}
        isAvailable={isAvailable}
        onClick={() => onProgrammeClick(programme.apiProgramme)}
        variant={isMobile ? 'mobile' : 'desktop'}
        isSelected={selectedProgrammeName === programme.name}
        centerText={true}
      />
    );
  };

  return <Carousel items={allProgrammes} renderItem={renderProgramme} itemHeight={isMobile ? '235px' : '280px'} gap={16} />;
};
